/// <reference path="../../_ext/editors/MFGTransItemGridEditor.ts" />
namespace TabAurous.Production {

    import fld = TreeMakingIssueRow.Fields;

    @Serenity.Decorators.registerClass()
    export class TreeMakingIssueEditor extends _Ext.MFGTransItemGridEditor<TreeMakingIssueRow> {
        protected getColumnsKey() { return "Production.TreeMakingIssue"; }
        protected getDialogType() { return TreeMakingIssueDialog; }
        protected getLocalTextPrefix() { return TreeMakingIssueRow.localTextPrefix; }

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        protected form: TreeMakingIssueForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        private Master;
        static baseitemcheck: number;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        }


        public setEditValue(source: TreeMakingRow, property) {

            //super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();
            Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                //this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                this.getItem(text);

                //TODO: Add method to get item from stock 
                //this.view.setItems(this.view.getItems(), true);
            });

            //let opt: Serenity.LookupEditorOptions = {
            //    lookupKey: OMS.CompanyRow.lookupKey
            //};

            //this.voucherType = Serenity.Widget.create({
            //    type: Serenity.LookupEditor,
            //    element: el => el.appendTo(this.toolbar.element).attr('placeholder', '--- ' +
            //        Q.text('Db.Administration.Translation.SourceLanguage') + ' ---'),
            //    options: opt
            //});

            //this.voucherType.changeSelect2(e => {


            //});
        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            var returngridlength = (this.parentDialog as TreeMakingDialog).form.ReceiptDetail.getItems().length;
            if (returngridlength != 0) {

                q.Alert('', 'Cannot Edit as Return Items exist', 1000, false);
                return;
            }
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }
                        //else if (y.field == "Pieces" && item.CalcOnId == 5) {
                        //    target.addClass('readonly');
                        //    target.blur();
                        //}
                        //else if (y.field == "Weight" && item.CalcOnId == 3) {
                        //    target.addClass('readonly');
                        //    target.blur();
                        //}
                    }

                    this.view.refresh();
                    (this.parentDialog as TreeMakingDialog).calculateIssuedData();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                let CurrentStock: Stock.StockItemRow;

                Stock.StockItemService.GetProductDetails({
                    ProductId: item.ProductId,
                    AttributeId: item.AttributeId,
                },
                    response =>
                        CurrentStock = response.Entity,
                    { async: false }
                );
                if (value > CurrentStock.Weight) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 3000, false);
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }

                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item[field] = value;
                    item.NetWeight = value;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as TreeMakingDialog).calculateIssuedData();
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.pop();

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Issue Metal",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {
                    var karatid = ((this.parentDialog as TreeMakingDialog).form.KaratId.value);
                    var metalcolorid = ((this.parentDialog as TreeMakingDialog).form.MetalColorId.value);
                    var rmdeptid= ((this.parentDialog as TreeMakingDialog).form.RMDepartmentId.value);
                    // **** Validate Party before Item Selection ****
                    if (karatid == "") {
                        Q.notifyWarning("Please select Karat to proceed");
                        return;

                    } else if (metalcolorid == "") {
                        Q.notifyWarning("Please select Metal Color to proceed");
                        return;

                    } else if (rmdeptid == "") {
                        Q.notifyWarning("Please select RM Department to proceed");
                        return;

                    } else {

                        var grid = Common.StockSelectGrid;

                        var filters: _Ext.SelectGridFilters = {
                            KaratId: parseInt(karatid),
                            MetalColorId: parseInt(metalcolorid),
                            FilterItems: 6,
                            DepartmentId: parseInt(rmdeptid)
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = [];
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {

                            var purity = 0;
                            var pureweight = 0;
                            //if (!value.HasBom) {
                            //    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                            //    //var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == PrdDetails.MetalId && x.RateTypeId == 33
                            //    //    && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") <= Q.formatDate(self.Master.TransDate, "dd/MM/yyyy"));
                            //    //Rate = MRate.pop().Rate;
                            //    if (value.Purity == 0)
                            //        value.Purity = OMS.AttributeMasterRow.getLookup().items.filter(x => x.AttributeId == value.KaratId)[0].StdPurity;
                            //    purity = OMS.AttributeMasterRow.getLookup().items.filter(x => x.AttributeId == value.KaratId)[0].StdPurity;
                            //}

                            if (!value.HasBom) {

                                var KaratId = Q.toId(value.KaratId);
                                var puritydetails: OMS.AttributeMasterRow;
                                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                    puritydetails = response.Entity
                                }, { async: false });
                                var std = puritydetails.StdPurity;
                                purity = std;
                                if (value.Purity == null)
                                    value.Purity = std;

                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }

                            var item: TreeMakingIssueRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Line_No: value.Line_No,
                                SKU: value.SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                Weight: value.Weight,
                                NetWeight: value.NetWeight,
                                CalcOnId: value.CalcOnId,
                                CompanyId: companyId,
                                Purity: purity,
                                PureWeight: pureweight,
                                LotNo: value.LotNo,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: value.VoucherTypeId

                            };
                            orddetails.push(item);

                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = orddetails.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = orddetails.length;
                        }
                        for (let TreeMakingDetail of orddetails) {
                            TreeMakingDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(TreeMakingDetail);
                        }
                        //new TreeMakingDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });



            return buttons;
        }



        // #endregion




        //validateEntity(row: TreeMakingIssueRow, id: number) {
        //    if (!super.validateEntity(row, id))
        //        return false;                                   

        //    row.ProductCode = OMS.ProductMasterRow.getLookup().itemById[row.ProductId].ProductCode;
        //    return true;
        //}    

        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in TreeMaking details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}